import Image from "next/image";
import { ComponentType, useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import ReactModal from "react-modal";

const Modal = ReactModal as unknown as ComponentType<ReactModal.Props>;

const desktopStyles: ReactModal.Styles = {
    content: {
        width: "730px",
        height: "253px",
        overflow: "hidden",
        padding: "0px",
        margin: "auto",
        top: "0px",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: 1000,
    },
};

const mobileStyles: ReactModal.Styles = {
    content: {
        width: "330px",
        height: "125px",
        overflow: "hidden",
        padding: "0px",
        margin: "300px auto",
        left: "15px",
        right: "15px",
        top: "0px",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: 1000,
    },
};

const BannerModal: React.FC = () => {
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const [isMobile, setIsMobile] = useState<boolean>(false);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            openModal();
        }, 7000);

        return () => clearTimeout(timer);
    }, []);

    const redirectPage = () => {
        window.open("https://gallabox.com/resources/free-whatsapp-message-templates", "_blank");
    };

    const checkMobileView = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    useEffect(() => {
        checkMobileView();
        window.addEventListener("resize", checkMobileView);
        return () => {
            window.removeEventListener("resize", checkMobileView);
        };
    }, []);

    return (
        <Modal isOpen={modalIsOpen} style={isMobile ? mobileStyles : desktopStyles} onRequestClose={closeModal}>
            <IoCloseOutline
                size="30px"
                style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    cursor: "pointer",
                }}
                className="text-white rounded-full hover:shadow-lg hover:text-white hover:bg-gray-400"
                onClick={closeModal}
            />
            <Image width={730} height={253} src="https://assets.gallabox.com/gb-home/cta-banner.png" alt="CTA Banner" style={{ cursor: "pointer" }} onClick={redirectPage} />
        </Modal>
    );
};

export default BannerModal;
